var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 16256"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h22v22H0z",
  "data-name": "Rectangle 6765"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 16256"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 21.925V0h21.925v21.925Z",
  "data-name": "Path 5188",
  opacity: 0.01
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#747474",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M15.411 16.728H8.103a4.568 4.568 0 0 1 0-9.136h10.049",
  "data-name": "Path 5189"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#747474",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m16.051 9.875 2.339-2.339-2.339-2.338",
  "data-name": "Path 5190"
})))));
export { SvgForward as ReactComponent };
export default __webpack_public_path__ + "static/media/forward.e8503a6842232bea5dfd9f78496f8b21.svg";